class NavbarController {
  /*@ngInject*/
  constructor(User, $rootScope, Auth, $state, $document, BranchService, $location, $translate, UserService, $q, UsersService, 
              $window, SetupService, Sound, HomeService, Configs, CommonLayoutService) {
    this.User = User
    this.$rootScope = $rootScope
    this.Auth = Auth
    this.$state = $state
    this.userInfo = User.getUser()
    this.isUserLoggedIn = User.isSignedIn()
    this.BranchService = BranchService;
    this.$location = $location;
    this.$translate = $translate;
    this.SetupService = SetupService;
    this.permissions = []
    this.UserService = UserService;
    this.UsersService = UsersService;
    this.HomeService = HomeService;
    this.Configs = Configs;
    this.$q = $q;
    this.$document = $document;
    this.userBranches = {};
    this.window = $window;
    this.Sound = Sound;
    this.audio = this.Sound.errorBeep();
    this.successAudio = this.Sound.successBeep();
    let data = User.getACL('navbar');
    let perMap = Auth.permissionMap();
    this.callOnce = true;
    this.hideBranchDD = false;
    this.CommonLayoutService = CommonLayoutService;
    let permissionOrder = ['tnt_billing', 'tnt_control', 'branch_mgmt', 'vault_balance', 'vault_operations', 'service_tickets', 'reporting', 'setting', 'divider', 'shipment_batch', 'bulk_cash_management', 'bulk_transfer', 'order_packing', 'route_throw', 'route_control', 'check_out','on_demand_call', 'cash_activity','ach_management','coin_management','pickup_request_management', 'check_in', 'atm_count', 'bag_out', 'atm_codes_management', 'fuel_surcharges', 'master_cash_schedule', 'route_progress', 'route_stats', 'deposit_packing', 'tnt_react_app', 'tnt_app_event_logs', 'divider', 'route_sheet', 'coin_pull_report', 'vault_close'];
    this.menuOrder = ['users', 'branch', 'batch', 'location', 'routes', 'item', 'carrier', 'truck', 'holiday', 'branch-funding-source', 'branch-funding-source-holiday', 'log', 'reset-atm-code', 'soft-deleted-shipments', 'service-settings', 'preventative-maintenance']
    const hasBulkTransferMenuAccess = (aclData) => {
      if (!aclData || angular.equals({}, aclData)) return false;
      if (aclData.bulk_transfer && aclData.bulk_transfer.indexOf('all') >= 0) return true;
      return ['bulk_transfer_new', 'bulk_transfer_active', 'bulk_transfer_closed'].some((resource) => {
        const resourcePermissions = aclData[resource];
        return resourcePermissions instanceof Array && resourcePermissions.indexOf('view') >= 0;
      });
    };
    for (let [key, permissions] of Object.entries(permissionOrder)) {
      let menuConfig
      if (permissions === 'bulk_transfer' && hasBulkTransferMenuAccess(data)) {
        menuConfig = perMap[permissions];
      } else if (permissions in data) {
        menuConfig = perMap[permissions];
      }
      else {
        if (!angular.equals({}, data)) {
          menuConfig = permissions;
        } else {
          menuConfig = false;
        }
      }
      if (menuConfig) {
        this.permissions.push(menuConfig)
      }
    }

    let configureListener = () => {
      this.$rootScope.$on('userChanged', (evt, user) => {
        this.isUserLoggedIn = !!user;
        if (this.isUserLoggedIn) {
          this.userInfo = user
          this.$q.all([
            this.BranchService.get(this.userInfo.branchId),
            // this.UserService.getUserBranchGroup(this.userInfo.id)
          ])
            .then((data) => {
              this.userInfo.branch = data[0];
              this.userInfo.branchLink = this.getBranchLink();
              // this.userBranches = data[1];
            }).catch(e => {
              console.log(`error ${e}`);
            })
        }
      });
    }
    configureListener()

    // setInterval(() => {
    //   if (!this.isUserLoggedIn) return;
    //   // if (this.userInfo && this.userInfo.branchLiability) {
    //   this.getBranchLiability();
    //   // this.callOnce = false;
    //   // }
    // }, 900000)

    // setInterval(() => {
    //   if (this.userInfo && !this.userInfo.branchLiability && this.callOnce) {
    //     this.getBranchLiability();
    //     this.callOnce = false;
    //   }
    // }, 1000)
  }

  getBranchLiability() {
    this.HomeService.getBranchLiability(this.userInfo.branchId)
      .then((data) => {
        this.userInfo.branchLiability = data.results;
      })
      .catch((err) => {
        console.log(err);
      })
  }

  shiftBranch(selectedBranch) {
    this.loading = true;
    var savedata = {
      id: this.userInfo.id,
      branchId: selectedBranch.branchId
    };
    this.UsersService.updateUserBranch(savedata.id, savedata)
      .then((data) => this.HomeService.getBranchLiability(selectedBranch.branchId).then((branchLiabilityObj) => [data, branchLiabilityObj.results]))
      .then(([data, branchLiability]) => {
        data.branchLiability = branchLiability;
        this.User.setUser(data);
        this.loading = false;
        // this.$state.go('home');
        setTimeout(function () { this.window.location.reload(); }, 100);
      })
      .catch((err) => {
        this.loading = false;
        err.data.errors.map((e) => {
          this.errorMessage += e.message + '<br/>'
        })
      })
  }

  menuItemClicked(menu) {
    if (menu.state == 'settings') {
      this.pageHeader = undefined;
      for (let i = 0; i < this.menuOrder.length; i++) {
        if (this.aclPermissions['setting-' + this.menuOrder[i]] && this.aclPermissions['setting-' + this.menuOrder[i]].indexOf('view') >= 0) {
          if (this.menuOrder[i] === 'preventative-maintenance') {
            this.window.open('/v2/index.html#/preventative-maintenance', '_self');
          } else {
            this.go('/app/settings/' + this.menuOrder[i] + '/all/1');
          }
          break;
        }
      }
    }
    else if (menu.state === 'routeStats') {
      var url = this.$state.href(menu.state);
      this.window.open(url, '_blank');
    }
    else if (menu.state === "tntReactApp") {
      var url = this.$state.href(menu.state);
      this.window.open(url, "_blank");
    }
    else if (menu.state === "onDemandCall") {
      var url = this.$state.href(menu.state);
      setTimeout(() => {
        this.window.open(url, "_self");
      }, 200)
    }
    else if (menu.state === "pickupRequestManagement") {
      var url = this.$state.href(menu.state);
      setTimeout(() => {
        this.window.open(url, "_self");
      }, 200)
    }
    else if (menu.state === "coinManagement") {
      var url = this.$state.href(menu.state);
      setTimeout(() => {
        this.window.open(url, "_self");
      }, 200)
    }
    else if (menu.state === "cashActivity") {
      var url = this.$state.href(menu.state);
      setTimeout(() => {
        this.window.open(url, "_self");
      }, 200)
    }
    else if (menu.state === "bulkTransfer") {
      setTimeout(() => {
        this.window.open('/v2/index.html#/bulk-transfer', '_self');
      }, 200)
    }
    else if (menu.state === "achManagement") {
      var url = this.$state.href(menu.state);
      setTimeout(() => {
        this.window.open(url, "_self");
      }, 200)
    }
     else if (menu.state === "appEventLogs") {
      var url = this.$state.href(menu.state);
      setTimeout(() => {
        this.window.open(url, "_self");
      }, 200)
    }
    else {
      this.$state.go(menu.state, {}, { reload: true });
    }
    this.setPageWidth()
  }

  go(path) {
    // this.$state.reload();
    this.$location.path(path);
  };

  getBranchLink() {
    const permissions = this.User.getACL('setting-branch');
    if (permissions && permissions instanceof Array && permissions.includes('edit')) {
      return `/app/settings/branch/edit/${this.userInfo.branchId}`;
    }
    else {
      return '#';
    }
  }

  $onInit() {
    this.$q.all([
      this.BranchService.get(this.userInfo.branchId),
      this.UserService.getUserBranchGroup(this.userInfo.id),
      this.UserService.acl(this.userInfo.id, this.userInfo.branchId),
      this.SetupService.all(null, 0, 100),
      this.UsersService.validateUserPermissions(this.userInfo.firstName, this.userInfo.lastName)
    ])
      .then((data) => {
        this.userInfo.branch = data[0];
        this.userInfo.branchLink = this.getBranchLink();
        this.allBranches = data[3].results;
        if (data[1].length && this.allBranches.length) {
          this.userBranches = [];
          data[1].forEach((selectedBranch) => {
            this.allBranches.filter((data) => {
              if (data.branchId == selectedBranch.branchId) {
                this.userBranches.push(selectedBranch)
              }
            })
          })
        }
        this.aclPermissions = data[2];
        const permissions = data[4];

        if (!permissions.hasAtmCodesPermission && !this.CommonLayoutService.isAllowToAccessPages()) {
          this.permissions = this.permissions.filter((pr) => {
            return pr.state !== 'atmCodesManagement'
          })

          if (this.validateUserPermissionsAndState('/atm-codes-management')) {
            return this.$state.go('home');
          }
        }

        if (!permissions.hasSettingsPermission && !this.CommonLayoutService.isAllowToAccessPages()) {
          this.permissions = this.permissions.filter((pr) => {
            return pr.state !== 'settings'
          })

          if (this.validateUserPermissionsAndState('/settings')) {
            return this.$state.go('home');
          }
        }

        if (!permissions.vaultOpartionPermission && !this.CommonLayoutService.isAllowToAccessPages()) {
          this.permissions = this.permissions.filter((pr) => {
            return pr.state !== "vaultOperations"
          })

          if (this.validateUserPermissionsAndState('/vault-operations')) {
            return this.$state.go('home');
          }
        }


        this.setPageWidth();
      })
      .catch((err) => {
        console.log(err);
      })

    this.$rootScope.$on('routeChange', (evt, url) => {
      if (url == '/app/home' || url == '/app/user-profile') return this.pageHeader = undefined;
      else if (url == '/app/atm-codes-management') return this.pageHeader = this.$translate.instant('navbar.atm_codes_management');
      else if (url == '/app/atm-count') return this.pageHeader = this.$translate.instant('branch_mgmt.cash_count');
      else if (url == '/app/deposit-packing') return this.pageHeader = this.$translate.instant('navbar.deposit_packing');
      else if (url == '/app/vault-close') return this.pageHeader = this.$translate.instant('navbar.vaultClose_title');
      else if (url == '/app/routeControl') return this.pageHeader = this.$translate.instant('navbar.routeControl_title');
      else if (url == '/app/checkin') return this.pageHeader = this.$translate.instant('navbar.checkin_title');
      else if (url == '/app/checkout') return this.pageHeader = this.$translate.instant('navbar.checkout_title');
      else if (url == '/app/route-throw') return this.pageHeader = this.$translate.instant('navbar.route_title');
      else if (url == '/app/bag-out') return this.pageHeader = this.$translate.instant('navbar.bagout_title');
      else if (url == '/app/route-progress') return this.pageHeader = this.$translate.instant('navbar.routeProgress_title');
      else if (url == '/app/order-packing') return this.pageHeader = this.$translate.instant('navbar.order_packing');
      else if (url == '/app/currency-pick-report') return this.pageHeader = this.$translate.instant('navbar.currency_pick_report');
      // else if (url == '/app/bulk-cash-management') return this.pageHeader = this.$translate.instant('navbar.bulk_cash_management');
      else if (url == '/app/bulk-cash') return this.pageHeader = this.$translate.instant('navbar.bulk_cash');
      else if (url == '/app/shipment-batch') return this.pageHeader = this.$translate.instant('navbar.batch_title');
      else if (url == '/app/route-sheet') return this.pageHeader = this.$translate.instant('navbar.routeSheet_title');
      else if (url == '/app/coin-pull-report') return this.pageHeader = this.$translate.instant('navbar.coinPullReport_title');
      else if (url == '/app/service-tickets') return this.pageHeader = this.$translate.instant('navbar.serviceTickets_title');
      else if (url == '/app/fuel-surcharges') return this.pageHeader = this.$translate.instant('navbar.fuel_surcharge_title');
      else if (url == '/app/route-stats') return this.pageHeader = this.$translate.instant('navbar.route_stats_title');
      else if (url == '/app/master-cash-schedule') return this.pageHeader = this.$translate.instant('navbar.master_cash_schedule');
      else if (url == '/app/vault-operations') return this.pageHeader = this.$translate.instant('navbar.vault_operations');
      else if (url == '/app/branch-management/item-holds') return this.pageHeader = this.$translate.instant('navbar.shipment_holds');
      else return this.pageHeader = undefined;
    })

    this.$rootScope.$on('updateBranchLiability', (evt, liabilityObj) => {
      if (liabilityObj.isVaultLiabilityChange && this.userInfo.branchLiability && typeof this.userInfo.branchLiability === 'object') {
        this.HomeService.updateVaultLiability(liabilityObj.branchId, liabilityObj.vaultLiability)
          .then(() => {
            if (liabilityObj.branchId === this.userInfo.branchId) {
              this.userInfo.branchLiability.vault_liability = liabilityObj.vaultLiability;
              this.User.setUser(this.userInfo);
            }
          })
          .catch((err) => {
            console.log(err);
          })
      }
    })
  }

  logout() {
    this.Auth.logout()
      .then(() => {
        this.User.clearUser()
        this.$state.go('login')
      })
      .catch((err) => {
        console.log(err);
      });
  }

  setPageWidth() {
    if (this.$state.current && this.$state.current.name && this.$state.current.name == 'routeStats') {
      angular.element(this.$document).find('body').css('max-width', '100%');
      this.hideBranchDD = true;
      // console.log('call', this.$state.current)

    } else {
      // console.log('call', this.$state.current)
      angular.element(this.$document).find('body').css('max-width', '1280px');
      this.hideBranchDD = false;
    }
  }

  validateUserPermissionsAndState(wordToCheck) {
    let currentStateUrl = this.$state.href(this.$state.current);
    return currentStateUrl.toLowerCase().includes(wordToCheck)
  }

}
export default NavbarController



// WEBPACK FOOTER //
// ./client/app/common/navbar/navbar.controller.js